export const CURRENCY_SYMBOL: Record<string, string> = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  CAD: "$",
  AUD: "$",
};

export const SUPPORTED_CURRENCIES: Record<string, string> = {
  USD: "USD",
  EUR: "EUR",
  GBP: "GBP",
  CAD: "CAD",
  AUD: "AUD",
};

export interface CurrencyProps {
  code: string;
  symbol: string;
}

export interface CurrencyConversionRates {
  [key: string]: number;
}

export interface CurrencyContextProps {
  currency: CurrencyProps;
  setCurrency: (data: CurrencyProps) => void;
  currencyConversionRates: CurrencyConversionRates;
  setCurrencyConversionRates: (data: CurrencyConversionRates) => void;
  isLoading: boolean;
}
